import {PARAMETER_TRANSACTION_ID, SESSION_KEY_TRANSACTION_DATA} from "../../../../pages/config/settings";
import {MAX_LENGTH_PRODUCT_GREETING} from "../../../doctypes/P020DonationProduct/P020DonationProductForm";
import {DONATION_TYPE, GIFT_CERTIFICATE_PDF_DATA, PHONE, SPONSORSHIP_TYPE} from "./constants";
import {
    AdditionalDocTypeParameters,
    DonationType,
    FormData, TransactionData
} from "../types";

export const isValidEnumValue = <T extends Record<string, number | string>>(value: any, enumObject: T): boolean =>
    Object.values(enumObject).includes(value);

export const getSinglePresetValue = <T>(array?: T[]): T | undefined => {
    if (Array.isArray(array) && array.length === 1) {
        return array[0];
    }
    return undefined;
}

export const filterAvailableOptions = <T extends { value: string | number }>(
    options: T[],
    values: (string | number)[]
): T[] => {
    return values.length === 0
        ? options
        : options.filter(option => values.includes(option.value));
};

export const formatAmountAsCurrency = (amount: number): string => {
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
};

// TODO revise if necessary: copied from F001DonationForm without changes
export const createTransactionData = (formData: any) => {
    const donationType = formData.donationType ? formData.donationType : 0;
    const sponsorshipType = formData.sponsorshipType ? formData.sponsorshipType : -1;
    const donationRhythm = formData.donationRhythm ? formData.donationRhythm : 0;
    const donatorType = formData.donatorType ? formData.donatorType : 'PrivatePerson';
    const gift = formData?.gift;
    const newsletter = formData?.newsletter;
    const paymentMethod = formData.paymentMethod ? formData.paymentMethod : 'sepa';
    const amount = formData.amount ? formData.amount : 0;
    const priority = formData.priority ? formData.priority : 'undefined';
    const quantity = formData.productQuantity ? formData.productQuantity : 1;
    const itemId = formData.productId ? formData.priority : undefined; // for products, itemId should be set from priority, because the article number ist set as priority
    return new TransactionData(donationType, sponsorshipType, donationRhythm, donatorType, gift, newsletter, paymentMethod, amount, priority, quantity, itemId);
}

export const addAdditionalDocTypeParameters = (additionalDocTypeParameters: AdditionalDocTypeParameters | undefined | null, formData: FormData)=> {
    if (!additionalDocTypeParameters) {
        return;
    }
    const additionalDocTypeParametersKeys = Object.keys(additionalDocTypeParameters);
    additionalDocTypeParametersKeys.forEach((parameter) => {
        if (parameter == "actionId") {
            formData.actionId =  additionalDocTypeParameters["actionId"]
        }
        if (parameter == "cmCsId") {
            formData.cmCsId = additionalDocTypeParameters["cmCsId"]
        }
    });
}

export const sanitizeFormData = (formData: FormData) => {
    const donationType = formData[DONATION_TYPE];

    if (donationType === DonationType.Donation || donationType === DonationType.Product) {
        formData[SPONSORSHIP_TYPE] = null;
    }
    delete formData[GIFT_CERTIFICATE_PDF_DATA];

    const phone = formData[PHONE]
    // Delete phone field if empty or only whitespace
    if (!phone || phone.trim() === "") {
        delete formData[PHONE];
    }
    return formData;
};


// TODO revise if necessary: copied from F001DonationForm without changes
export const addTransactionData = (session: any, data: any, tId: string | undefined): string => {
    const transactionId = data.transactionId ? data.transactionId : tId;
    if (transactionId) {
        const transactionData = createTransactionData(data);
        session.addToSession(PARAMETER_TRANSACTION_ID, transactionId);
        session.addJsonToSession(SESSION_KEY_TRANSACTION_DATA, transactionData);
    }
    return transactionId;
}

export const blobToBase64 = (blob: Blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export const getErrorElement = (fieldName: string): HTMLElement | null => {
    if (fieldName === 'amount') {
        return document.getElementById('freeAmount');
    }
    return document.querySelector(`[name="${fieldName}"]`) as HTMLElement | null;
};

export function validProductDonation(quantity: any, firstname: string, surname: string, greeting: string): boolean {
    const trimmedFirstname = (firstname || "").trim();
    const trimmedSurname = (surname || "").trim();
    const greetingValid = greeting === undefined || (greeting ?? "").length <= MAX_LENGTH_PRODUCT_GREETING;
    const quantityValid = typeof quantity === 'number'
        ? quantity >= 1
        : new RegExp('^[1-9][0-9]*$').test(String(quantity || ''));
    return  quantityValid && !!trimmedFirstname && !!trimmedSurname && greetingValid;
}

